/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

/*-----------------------------------------------------------------------------/
/ Klaviyo "Added to Cart" tracking
/-----------------------------------------------------------------------------*/
document.addEventListener('on:cart:loaded', (event) => {
  if (event.detail.type !== 'ADD') return;

  const cart = event.detail.cart;
  window._learnq = window._learnq || [];
  window._learnq.push([
    'track',
    'Added to Cart',
    {
      total_price: cart.total_price / 100,
      $value: cart.total_price / 100,
      total_discount: cart.total_discount,
      original_total_price: cart.original_total_price / 100,
      items: cart.items,
    },
  ]);
});
